import { render, staticRenderFns } from "./text-writer-word-count.vue?vue&type=template&id=1382ce92&scoped=true"
import script from "./text-writer-word-count.ts?vue&type=script&lang=ts&external"
export * from "./text-writer-word-count.ts?vue&type=script&lang=ts&external"
import style0 from "./text-writer-word-count.less?vue&type=style&index=0&id=1382ce92&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1382ce92",
  null
  
)

export default component.exports